import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Accordion, Icon } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import { StylePropType } from 'libs/proptypes';

import StyleConfigurationTable from '../StyleConfigurationTable';

import './StyleConfigurationAccordionTable.scss';

const propTypes = {
  cssRules: PropTypes.arrayOf(PropTypes.string).isRequired,
  style: StylePropType,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  style: {},
};

export default function StyleConfigurationAccordionTable({ cssRules, style, onChange }) {
  const [activeIndex, setActiveIndex] = useState(_isEmpty(style) ? -1 : 0);

  function onClick(e, { index }) {
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  }

  return (
    <Accordion className="style-configuration-accordion-table">
      <Accordion.Title active={activeIndex === 0} index={0} onClick={onClick}>
        Edit Style
        <Icon name="dropdown" />
      </Accordion.Title>
      <Accordion.Content active={activeIndex === 0}>
        <StyleConfigurationTable cssRules={cssRules} style={style} onChange={onChange} />
      </Accordion.Content>
    </Accordion>
  );
}

StyleConfigurationAccordionTable.propTypes = propTypes;
StyleConfigurationAccordionTable.defaultProps = defaultProps;
